import { render, staticRenderFns } from "./listCattleGrade.vue?vue&type=template&id=1791b91d&scoped=true"
import script from "./listCattleGrade.vue?vue&type=script&lang=js"
export * from "./listCattleGrade.vue?vue&type=script&lang=js"
import style0 from "./listCattleGrade.vue?vue&type=style&index=0&id=1791b91d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1791b91d",
  null
  
)

export default component.exports